<template>
  <c-widget-control-bar>
    <c-widget-input-symbol
      :autocompleteInstruments="['STO', 'IND', 'CER', 'WAR', 'FUN', 'BON']"
      :disabled="controlFilter && Boolean(controlWatchlist)"
      :label="i18n('labels.symbols')"
      :maxTags="maxTags"
      multicolor
      :placeholder="i18n('placeholders.symbols')"
      :value="controlFilter && Boolean(controlWatchlist) ? [] : symbols"
      @input="$emit('symbolsInput', $event)"
      detached
      detachedClass="w-news-widget"
    />

    <v-form-group :label="i18n('labels.topics')" label-cols="auto">
      <v-form-tags
        :autocompleteMinLength="0"
        :autocomplete-items="filteredTopics"
        :addOnlyFromAutocomplete="false"
        class="topic-control"
        :maxTags="maxTags"
        multicolor
        :placeholder="i18n('placeholders.topics')"
        :value="topicsTags"
        @input="$emit('topicsInput', $event)"
        @inputText="onTopicsInputText"
        detached
        detachedClass="w-news-widget"
      >
        <template slot="autocomplete-item" slot-scope="props">
          <div @click="onTopicsListItemClick(props)">
            {{ `${props.item.label}` }}
          </div>
        </template>
      </v-form-tags>
    </v-form-group>

    <v-form-group :label="i18n('labels.keywords')" label-cols="auto">
      <v-form-tags
        :addOnlyFromAutocomplete="false"
        :maxTags="maxTags"
        multicolor
        :placeholder="i18n('placeholders.keywords')"
        :validation="keywordValidator"
        :value="keywordsTags"
        @input="$emit('keywordsInput', $event)"
      />
    </v-form-group>

    <c-widget-control-bar-group inline>
      <v-form-checkbox :checked="controlFilter" @input="$emit('filterChanged', $event)">{{
        i18n('labels.filter')
      }}</v-form-checkbox>
      <v-form-select
        :disabled="!controlFilter"
        label=""
        :value="controlWatchlist"
        :options="optionsWatchlists"
        @input="$emit('watchlistsChanged', $event)"
        :aria-label="i18n('labels.filter')"
      />
    </c-widget-control-bar-group>
  </c-widget-control-bar>
</template>

<script>
import CWidgetControlBar from '@custom/widgetContainer/CWidgetControlBar';
import CWidgetControlBarGroup from '@custom/widgetContainer/CWidgetControlBarGroup';
import CWidgetInputSymbol from '@custom/widgetContainer/CWidgetInputSymbol';
import newsTopics from '@/utils/newsTopics.json';
import widgetCommons from '@mixins/widgetCommons';

export default {
  name: 'w-control-bar',
  mixins: [widgetCommons],
  components: {
    CWidgetControlBar,
    CWidgetControlBarGroup,
    CWidgetInputSymbol
  },
  props: {
    wid: {
      type: String,
      required: true
    },
    maxTags: {
      type: Number,
      required: true
    },
    symbols: {
      type: Array,
      required: true
    },
    topics: {
      type: Array,
      required: true
    },
    keywordsTags: {
      type: Array,
      required: true
    },
    controlFilter: {
      type: Boolean,
      required: true
    },
    controlWatchlist: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      keywordValidator: [{ rule: /^\S*$/, disableAdd: true, classes: 'no-spaces' }],
      topicsInputText: ''
    };
  },
  computed: {
    filteredTopics() {
      return Object.entries(newsTopics).reduce((acc, [group, items]) => {
        const path = group === 'country' ? 'white-label.countries.' : 'white-label.widgets.news.topics.codes.';
        const filteredItems = items.reduce((acc, item) => {
          if (
            this.$t(path + item)
              .toLowerCase()
              .includes(this.topicsInputText.toLowerCase()) &&
            !this.topics.includes(item)
          ) {
            acc.push(item);
          }
          return acc;
        }, []);
        if (filteredItems.length) {
          acc.push({
            classes: 'group-header',
            label: this.i18n('topics.sections.' + group),
            text: 'dummy'
          });
          let sortedItems = [];
          filteredItems.forEach(item => {
            sortedItems.push({
              label: this.$t(path + item) + ` (${item})`,
              text: item
            });
          });
          sortedItems = sortedItems.sort((a, b) => {
            var x = a.label.toLowerCase();
            var y = b.label.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
          acc = acc.concat(sortedItems);
        }
        return acc;
      }, []);
    },
    optionsWatchlists() {
      return [
        {
          classes: 'placeholder',
          text: this.$t('white-label.widgets.watchlist.widget-title'),
          value: ''
        },
        ...this.watchlists.map(watchlist => ({
          text: watchlist.name,
          value: watchlist.id
        }))
      ];
    },
    topicsTags() {
      return this.topics.map(topic => ({ text: topic === 'ALL' ? this.i18n('topics.sections.all') : topic }));
    },
    watchlists() {
      return this.$store.getters['watchlists/watchlistsSorted'];
    }
  },
  methods: {
    onTopicsInputText(text) {
      this.topicsInputText = text;
    },
    onTopicsListItemClick(props) {
      if (props.item.classes !== 'group-header') props.performAdd(props.item);
    }
  }
};
</script>
